<div class="model-title">
  <h1 class="title">Generate Auto Post Asset</h1>
</div>
<mat-dialog-content class="model">
  <mat-form-field appearance="outline" color="primary" class="dialog-input">
    <mat-label>Model</mat-label>
    <mat-select [(value)]="selectedModel">
      @for (model of models; track model) {
      <mat-option [value]="model">{{ model }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline" color="primary" class="dialog-input">
    <mat-label>Rt Profile</mat-label>
    <mat-select [(value)]="selectedRtProfile">
      @for (rtProfile of rtProfiles; track rtProfile) {
      <mat-option [value]="rtProfile">{{ rtProfile }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline" color="primary" class="dialog-input">
    <mat-label>Pipeline</mat-label>
    <mat-select [(value)]="selectedAutoPipeline">
      @for (pipeline of autoPipelines; track pipeline) {
      <mat-option [value]="pipeline">{{ pipeline }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end" class="action">
  <button mat-stroked-button mat-dialog-close>Cancel</button>
  <button
    mat-stroked-button
    color="buttonSuccess"
    class="save"
    cdkFocusInitial
    (click)="generateAutoPostAsset()"
  >
    Generate
  </button>
</mat-dialog-actions>
